import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CloseButton from './CloseButton';
import ScoreRadio from './ScoreRadio';
import {
  BreakPoint,
  Color,
  FontSize,
  Font,
  Coordinates,
} from '../styles/constants';

const Box = styled.div`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.darkRed};
  box-sizing: border-box;
  font-family: ${Font.default};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    width: 456px;
    bottom: 32px;
    top: auto;
    left: auto;
    right: ${Coordinates.right};
  }

  * {
    font-family: ${Font.default};
  }
`;

const FlexBox = styled.div`
  display: flex;
`;

const MessageBox = styled(FlexBox)`
  justify-content: flex-end;
  margin-bottom: 32px;
`;

const Message = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  margin-top: 8px;

  @media (min-width: ${BreakPoint.desktop}) {
    flex: 1;
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

const Close = styled.div`
  margin-left: 20px;
`;

const ScoreToast = props =>
  props.isOpen && (
    <Box className={props.className}>
      <MessageBox>
        <Message>{props.message}</Message>
        <Close>
          <CloseButton onClick={props.onCloseClick} color="red" />
        </Close>
      </MessageBox>
      <ScoreRadio
        value={props.selectedValue}
        optionValues={props.values}
        onChange={props.onScoreClick}
        minScoreText={props.minScoreLabel}
        maxScoreText={props.maxScoreLabel}
      />
    </Box>
  );

ScoreToast.propTypes = {
  message: PropTypes.string.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  values: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  onScoreClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  minScoreLabel: PropTypes.string,
  maxScoreLabel: PropTypes.string,
  isOpen: PropTypes.bool,
};

ScoreToast.defaultProps = {
  selectedValue: undefined,
  onScoreClick: () => {},
  onCloseClick: () => {},
  minScoreLabel: undefined,
  maxScoreLabel: undefined,
  isOpen: false,
};

export default ScoreToast;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/ScoreToast.jsx